<template>
  <div class="content jaleklinico">
    <modal-visualiza-imagem ref="modalVisualizaImagem" :imagemVisualizar="imagemVisualizar"/>
    <h1><span><i class="fas fa-briefcase-medical"></i> Jaleklínico</span></h1>
    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1" v-if="!jaleklinico_edicao">ADICIONAR CASO CLÍNICO</h2>
        <h2 class="mt-1" v-else>EDITAR CASO CLÍNICO</h2>
      </div>
      <div class="col-12 col-md-6 text-center text-md-right">
        <a href="javascript:void(0)" class="btn-cancelar mr-3 mb-2 mb-md-0" @click="voltar()"> Voltar e cancelar</a>
        <a href="javascript:void(0)" id="rascunho" class="btn btn-primary mr-3 mb-2 mb-md-0"  @click="salvarRascunhoJaleklinico()"> Salvar como rascunho </a>
        <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0"  @click="cadastrarJaleklinico()" v-if="!jaleklinico_edicao"> Concluir Caso Clínico </a>
        <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="atualizarJaleklinico()" v-else> Salvar </a>
      </div>
    </div>
    <hr>
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-group">
          <form-group id="jaleklinico" label="Caso *" :text="{ required: 'Obrigatório informar o nome do caso' }" :field="$v.jaleklinico.jaleklinico">
            <input type="string" class="form-control" id="jaleklinico" v-model="jaleklinico.jaleklinico" placeholder="Digite o nome do caso"/>
          </form-group>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <form-group id="persona" label="Apresentação *" :text="{ required: 'Obrigatório informar a apresentação do caso' }" :field="$v.jaleklinico.persona">
             <textarea class="form-control" placeholder="Escreva aqui a apresentação do caso" id="persona" rows="3" v-model="jaleklinico.persona"></textarea>
          </form-group>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <form-group id="professor" label="Professor Responsável *" :text="{ required: 'Obrigatório informar o professor responsável pelo caso' }" :field="$v.jaleklinico.professor_criador_id">
            <select class="form-control" v-model="jaleklinico.professor_criador_id">
              <option v-if="professores.length == 0" value="">Carregando...</option>
              <option v-if="professores.length > 0" value="">Selecione</option>
              <option v-for="professor in professores" :value="professor.id">{{ professor.professor }}</option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <form-group id="especialidades" label="Especialidade" :field="jaleklinico.especialidade_id || ''">
            <select class="form-control" v-model="jaleklinico.especialidade_id">
              <option v-if="especialidades.length == 0" value="">Carregando...</option>
              <option v-if="especialidades.length > 0" value="">Selecione</option>
              <option v-for="especialidade in especialidades" :value="especialidade.id">{{ especialidade.especialidade }}</option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <form-group id="grandes_areas" label="Grande Área" :field="jaleklinico.grande_area_id || ''">
            <select class="form-control" v-model="jaleklinico.grande_area_id">
              <option v-if="grandes_areas.length == 0" value="">Carregando...</option>
              <option v-if="grandes_areas.length > 0" value="">Selecione</option>
              <option v-for="grande_area in grandes_areas" :value="grande_area.id">{{ grande_area.nome }}</option>
            </select>
          </form-group>
        </div>
      </div>
      <div class="col-3">
        <form-group label="Quem vai acessar?" :field="$v.jaleklinico.acesso" >
          <br>
             <select class="form-control" v-model="jaleklinico.acesso">
                <option value="Assinante">Assinante</option>
                <option value="Cadastrado">Cadastrado</option>
                <option value="Visitante">Visitante</option>
             </select>
        </form-group>
      </div>
      <div class="col-3">
        <div class="form-group">
          <form-group id="tipoStatus" label="Ativar / desativar caso" :field="$v.jaleklinico.status">
            <div class="custom-control custom-switch status-curso-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="jaleklinico.status" true-value="Ativo" false-value="Inativo">
              <label class="custom-control-label" for="customSwitch1" style="padding-top:5px;"> {{ jaleklinico.status }}</label>
            </div>
          </form-group>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mt-3">
        <h2>QUESTÕES E RESPOSTAS</h2>
      </div>
    </div>
     <hr>
      <div class="d-flex align-items-center justify-content-between">
        <div class="row">
        <!-- <div class="d-flex align-items-center flex-grow-1"> -->
          <draggable v-model="jaleklinico.perguntas" @end="finalMovePergunta" class="col-md-12">
            <div v-for="(pergunta, ixPergunta) in jaleklinico.perguntas" :key="pergunta.id" class="questao-jaleklinico">
              <span class="circle-number"> {{ ixPergunta + 1 }} </span>
              <span class="close-circle" v-if="jaleklinico.perguntas.length > 1" href="javascript:void(0)" @click="excluirPergunta(ixPergunta, pergunta.id)"><i class="fas fa-minus-circle"></i></span>
              <div class="drag-interno pt-4 pl-4 pr-4 pb-4">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="titulo-enunciado">
                      <h2>Enunciado</h2>

                      <b-form-file @input="uploadImg(ixPergunta)"
                        v-model="imagem_selecionada"
                        placeholder="Inserir imagem"
                        browse-text="Selecionar"
                        accept="image/jpeg, image/png"
                        ref="formFile"
                        v-bind:id="'id'+ixPergunta"
                        style="display:none;"
                      ></b-form-file>
                      <a href="javascript:void(0)" @click="searchFile(ixPergunta)" rel="noopener noreferrer"><i class="fas fa-image"></i> Inserir Imagem</a>
                      <div class="lista-imagens">
                        <template v-for="(imagem, ixImagem) in jaleklinico.perguntas[ixPergunta]['imagem_nomes']">
                          <a @click="visualizarImagem(imagem)" href="javascript:void(0)" rel="noopener noreferrer" :key="ixImagem">{{ imagem }}</a>
                          <a href="javascript:void(0)" @click="excluirImagem(ixPergunta, ixImagem)" :key="ixImagem+'ex'" v-b-tooltip.hover title="Excluir">
                              <i class="fas fa-minus-circle"></i>
                          </a>
                          <template v-if="jaleklinico.perguntas[ixPergunta]['imagem_nomes'].length > ixImagem + 1"> | </template>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <textarea class="form-control col-md-12 ml-3" :placeholder="pergunta.final ? 'Escreva aqui o texto de conclusão' : 'Escreva aqui o enunciado'" :id="'pergunta'+ixPergunta" rows="3" v-model="pergunta.pergunta"></textarea>
                  </div>
                    <div class="col-12 col-md-12">
                      <div class="titulo-link">
                      <h2>Link</h2>
                      </div>
                    </div>
                  <div class="col-12 col-md-12">
                    <input class="form-control col-md-12 ml-3" :id="'link'+ixLink" rows="3" v-model="pergunta.link">
                  </div>
                  <draggable v-model="jaleklinico.perguntas[ixPergunta]['alts']">
                    <div v-for="(alternativa, ixAlternativa) in jaleklinico.perguntas[ixPergunta]['alts']" :key="ixAlternativa" class="drag-interno ml-5 mt-4 pl-2 alternativas list-group-item">
                      <div class="row">
                        <div class="col-9 col-md-9">
                          <div class="titulo-enunciado">
                            <h2 class="ml-2">Alternativa {{ ixAlternativa + 1 }}</h2>
                          </div>
                          <div class="col-12 col-md-12">
                            <input class="form-control" placeholder="Insira o texto" type="text" name="alternativa" size="100" v-model="alternativa.alternativa"/>
                          </div>
                        </div>
                        <div class="col-2 col-md-2 m-0 p-0">
                          <div class="titulo-enunciado">
                            <h2>Pts Perdidos <i class="fas fa-info-circle"></i></h2>
                          </div>
                          <div class="col-12 col-md-12">
                            <div class="input-pontos">
                              <button v-if="alternativa.pontos_negativos > -10" @click="alternativa.pontos_negativos = parseFloat(alternativa.pontos_negativos) - 1"> - </button>
                                <span v-html="alternativa.pontos_negativos"></span>
                              <button v-if="alternativa.pontos_negativos < 0" @click="alternativa.pontos_negativos = parseFloat(alternativa.pontos_negativos) + 1"> + </button>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-1">
                          <span class="close-circle-alt" v-if="jaleklinico.perguntas[ixPergunta]['alts'].length > 1" href="javascript:void(0)" @click="excluirAlternativa(ixPergunta,ixAlternativa)"><i class="fas fa-minus-circle"></i></span>
                        </div>
                      </div>
                      <div class="row ml-2 mt-3">
                        <div class="col-md-11 d-flex align-items-center justify-content-between">
                          <i class="fas fa-crosshairs mr-2"></i>
                          <select class="form-control" v-model="alternativa.alvo">
                              <option value="0">Selecione a questão alvo</option>
                              <option v-for="(item) in jaleklinico.perguntas.filter(item => item.pergunta != '')" :value="item.id" :label="item.pergunta.substring(0,30) + '...'" :key="item.id"/>
                          </select>
                          <i class="fas fa-info-circle ml-2"></i>
                        </div>
                      </div>
                    </div>
                  </draggable>
                  <div class="col-md-12 ml-5 mt-4 pl-2">
                    <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0"  v-if="!pergunta.final" @click="adicionarAlternativa(ixPergunta)"><i class="fas fa-plus"></i> Adicionar alternativa</a>
                  </div>
                  <div v-if="ixPergunta > 1" class="col-md-11 ml-5 mt-4 pl-2">
                    <hr>
                  </div>
                  <div v-if="ixPergunta > 0" class="col-md-12 mt-4 text-center">
                    <input type="checkbox" @change="checkFinal(ixPergunta)" class="mr-1" v-model="pergunta.final"> Marque aqui se a questão for final do fluxo
                    <i class="fas fa-info-circle ml-2" v-b-popover.hover.top="'Marque aqui se essa for a questão final do fluxo.'"></i>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
          <div class="col-md-12 adicionar-questao">
            <a href="javascript:void(0)" id="cadastrar" class="btn btn-secondary mr-3 mb-2 mb-md-0"  @click="adicionarPergunta()"><i class="fas fa-plus"></i> Adicionar questão</a>
          </div>
        <!-- </div> -->
        </div>
      </div>
      <div class="col-12 col-md-12 text-center mt-3">
        <a href="javascript:void(0)" class="mr-3 mb-2 mb-md-0 btn-cancelar" @click="voltar()"> Voltar e cancelar</a>
        <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0"  @click="cadastrarJaleklinico()" v-if="!jaleklinico_edicao"> Concluir Caso Clínico </a>
        <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="atualizarJaleklinico()" v-else> Salvar </a>
      </div>
  </div>
</template>

<script>

import EspecialidadeAPI from '@/api/especialidade-api'
import JaleklinicoAPI from '@/api/jaleklinico-api'
import ProfessorAPI from '@/api/professor-api'
import ModalVisualizaImagem from '@/modules/Jaleklinico/components/ModalVisualizaImagem'
import FormGroup from '@/core/components/FormGroup'
import Swal from 'sweetalert2'
import { required } from 'vuelidate/lib/validators'
import ResponseUtils from '@/core/util/response-utils'
import draggable from 'vuedraggable'
import UrlUtils from '@/core/util/url-utils'
import GrandesAreasAPI from '@/api/grandes-areas-api'

export default {
  name: 'AdicionarJaleklinicoView',
  components: { FormGroup, draggable, ModalVisualizaImagem },
  props: {
    jaleklinico_edicao: Boolean,
    jaleklinico_selecionado: Object
  },
  data () {
    return {
      // imageData: '',
      erros: [],
      especialidades: [],
      professores: [],
      grandes_areas: [],
      jaleklinico: {
        professor_criador_id: '',
        especialidade_id: '',
        grande_area_id: '',
        jaleklinico: '',
        persona: '',
        status: 'Inativo',
        acesso: 'Assinante',
        perguntas: []
      },
      imagem_selecionada: [],
      imagemVisualizar: ''
    }
  },
  mounted () {
    if (this.jaleklinico_edicao) {
      this.jaleklinico = Object.assign({}, this.jaleklinico_selecionado)
      if (this.jaleklinico.especialidade_id === null) {
        this.jaleklinico.especialidade_id = ''
      }
      if (this.jaleklinico.grande_area_id === null) {
        this.jaleklinico.grande_area_id = ''
      }
      this.jaleklinico.perguntas.map(pergunta => {
        pergunta.imagem_files = []
      })
    } else {
      const pergunta = {
        'id': 1,
        'pergunta': '',
        'link': '',
        'final': false,
        'imagem_files': [],
        'imagem_nomes': [],
        'alts': [
          { 'alternativa': '',
            'pontos_negativos': '0',
            'alvo': '0' }
        ]
      }
      this.jaleklinico.perguntas.push(pergunta)
    }

    ProfessorAPI.listar().then(data => {
      this.professores = data
    })

    EspecialidadeAPI.listar().then(data => {
      this.especialidades = data
    })

    GrandesAreasAPI.listar().then(data => {
      this.grandes_areas = data
    })
  },
  methods: {
    checkFinal: function (ixPergunta) {
      if (this.jaleklinico.perguntas[ixPergunta].final) {
        this.jaleklinico.perguntas[ixPergunta]['alts'].splice(0, this.jaleklinico.perguntas[ixPergunta]['alts'].length)
        return
      }
      this.adicionarAlternativa(ixPergunta)
    },
    finalMovePergunta: function (evt) {
      if (evt.newIndex === 0) {
        this.jaleklinico.perguntas[0].final = false
        this.adicionarAlternativa(0)
        this.$forceUpdate()
      }
    },
    voltar: function () {
      this.$router.push('/jaleklinico/jaleklinicos')
    },
    cadastrarJaleklinico: function () {
      let idsPerguntas = this.validarJaleklinico()
      if (idsPerguntas.length > 0) {
        this.avisarErros(idsPerguntas)
        return
      }

      this.$v.jaleklinico.$touch()
      if (!this.$v.jaleklinico.$invalid) {
        const loader = this.$loading.show()

        JaleklinicoAPI.salvar(this.jaleklinico).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Jaleklinico criado com sucesso'
          }).then(() => {
            this.voltar()
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    salvarRascunhoJaleklinico: function () {
      const loader = this.$loading.show()
      this.jaleklinico.status = 'Inativo'
      if (!this.jaleklinico_edicao) {
        JaleklinicoAPI.salvar(this.jaleklinico).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Jaleklinico salvo como rascunho com sucesso'
          }).then(() => {
            this.voltar()
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      } else {
        JaleklinicoAPI.atualizar(this.jaleklinico).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Rascunho do Jaleklinico atualizado com sucesso'
          }).then(() => {
            this.voltar()
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    atualizarJaleklinico: function () {
      let idsPerguntas = this.validarJaleklinico()
      if (idsPerguntas.length > 0) {
        this.avisarErros(idsPerguntas)
        return
      }

      this.$v.jaleklinico.$touch()
      if (!this.$v.jaleklinico.$invalid) {
        const loader = this.$loading.show()

        JaleklinicoAPI.atualizar(this.jaleklinico).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Jaleklinico atualizado com sucesso'
          }).then(() => {
            this.voltar()
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    validarJaleklinico: function () {
      let idsPerguntas = []
      this.jaleklinico.perguntas.forEach((pergunta, ixPergunta) => {
        if (pergunta.pergunta === '') {
          idsPerguntas.push(ixPergunta + 1)
        }
        pergunta.alts.forEach((alternativa) => {
          if (alternativa.alternativa === '') {
            idsPerguntas.push(ixPergunta + 1)
          }
          if (alternativa.alvo === '0') {
            idsPerguntas.push(ixPergunta + 1)
          }
        })
      })
      return idsPerguntas
    },
    avisarErros: function (idsPerguntas) {
      this.erros = [...new Set(idsPerguntas)]
      let mensagem = 'As seguintes perguntas tem erros de preenchimento: '
      this.erros.forEach((id) => {
        mensagem = mensagem.concat(id, ',')
      })
      mensagem = mensagem.substring(0, mensagem.length - 1)
      Swal.fire({
        icon: 'error',
        showCloseButton: true,
        text: mensagem
      })
    },
    adicionarAlternativa: function (ixPergunta) {
      const alternativa = {
        'alternativa': '',
        'pontos_negativos': '0',
        'alvo': '0'
      }
      this.jaleklinico.perguntas[ixPergunta]['alts'].push(alternativa)
    },
    adicionarPergunta: function () {
      let ultimoId = Math.max(...this.jaleklinico.perguntas.map(item => item.id))
      const pergunta = {
        'id': ++ultimoId,
        'pergunta': '',
        'final': false,
        'imagem_files': [],
        'imagem_nomes': [],
        'alts': [ { 'alternativa': '', 'pontos_negativos': '0', 'alvo': '0' } ]
      }
      this.jaleklinico.perguntas.push(pergunta)
      this.$forceUpdate()
    },
    excluirAlternativa: function (ixPergunta, ixAlternativa) {
      this.jaleklinico.perguntas[ixPergunta]['alts'].splice(ixAlternativa, 1)
    },
    excluirPergunta: function (ixPergunta, perguntaId) {
      this.jaleklinico.perguntas.splice(ixPergunta, 1)
      this.$forceUpdate()
      this.jaleklinico.perguntas.forEach((pergunta) => {
        pergunta.alts.forEach((alternativa) => {
          if (alternativa.alvo === perguntaId) {
            alternativa.alvo = '0'
          }
        })
      })
    },
    uploadImg: function (ixPergunta) {
      if (this.imagem_selecionada) {
        this.jaleklinico.perguntas[ixPergunta].imagem_files.push(this.imagem_selecionada)
        this.jaleklinico.perguntas[ixPergunta].imagem_nomes.push(this.imagem_selecionada.name)
        this.imagem_selecionada = []
        this.$forceUpdate()
      }
    },
    excluirImagem: function (ixPergunta, ixImagem) {
      this.jaleklinico.perguntas[ixPergunta]['imagem_files'].map((file, index) => {
        if (file.name === this.jaleklinico.perguntas[ixPergunta]['imagem_nomes'][ixImagem]) {
          this.jaleklinico.perguntas[ixPergunta]['imagem_files'].splice(index, 1)
        }
      })
      this.jaleklinico.perguntas[ixPergunta]['imagem_nomes'].splice(ixImagem, 1)
    },
    obterUrlS3: function (imagem) {
      // let pasta = 'topicos-imagem'
      // return UrlUtils.obterUrlS3('topicos-imagem/' + imagem.url)
      return UrlUtils.obterUrlS3('topicos-imagem/')
    },
    visualizarImagem: function (imagem) {
      this.imagemVisualizar = imagem
      this.$nextTick(() => {
        this.$refs.modalVisualizaImagem.show()
      })
    },
    previewImage: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    searchFile: function (ixPergunta) {
      let fileInput = document.getElementById('id' + ixPergunta)
      fileInput.click()
    }
  },
  validations: {
    jaleklinico: {
      jaleklinico: { required },
      persona: { required },
      professor_criador_id: { required },
      status: { required },
      acesso: { required }
    }
  }
}
</script>
